export default __webpack_public_path__ + "static/media/LogoClusterEnfermedades.9d68ae74.png";